import React, { Component } from "react";
// import { Divider } from 'antd';
import "../App.scss";

class RMCP_250131 extends Component {

  public render() {
    return (
      <div className="Page">
        <h1> MIT Research Mentoring Certificate Program </h1>
        <h3> January 31, 2025 </h3>
        <p>
                This month I participated in the <a href="https://capd.mit.edu/pd-certificates/" target="_blank">MIT Research Mentoring Certificate Program</a>.
                
                This program is designed to help graduate students and postdocs develop their mentoring skills and philosophies. The program consists of 4 workshops, each of which focuses on a different aspect of mentoring, e.g. effective communication, aligning expectations, addressing inclusion, and assessing understanding.
            </p>
            <p> 
                During the course I developed my ideas for fostering an effective mentoring relationship. I plan on implementing techniques like: fostering independence through training on how to go from problem formulation to execution, setting clear expectations at the start of the mentoring relationship, and creating an inclusive environment where mentees feel comfortable asking questions and expressing their ideas.
            </p>
            <p>
                For those interested (including potential mentees!) I've uploaded a document outlining my mentoring philosophy <a href="https://docs.google.com/document/d/1xyaC9-WXK471BPGUfz3V3NIwWm1z34o7/edit?usp=sharing&ouid=110317802591666399465&rtpof=true&sd=true" target ="_blank">here</a>. I will be periodically updating this document as I gain more experience as a mentor.
            </p>
            <p> Thanks to the Career Advising & Professional Development office at MIT for putting on this certificate, and to the instructors Alex Yen and Elsie Otero for their insightful classes. I'm excited to continue to develop my mentoring skills and philosophy in the future! </p>

        
      </div>
    );
  }
}
export default RMCP_250131;
